import { IFilter } from 'core-components/types'

export const getValuesFromFilter = (filters: IFilter[]) => {
  const countryFilterValue = (filters.find((el) => el.field === 'Country')?.value as string) || ''
  const marketFilterValue = (filters.find((el) => el.field === 'GeoMarket')?.value as string) || ''
  const partnerIdFilterValue =
    (filters.find((el) => el.field === 'PartnerID')?.value as string) || ''
  const partnerNameFilterValue =
    (filters.find((el) => el.field === 'CommunicationName')?.value as string) || ''

  return {
    countryFilterValue,
    marketFilterValue,
    partnerIdFilterValue,
    partnerNameFilterValue,
  }
}
